<template>
  <div class="fromStyle">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目" prop="project_id">
        <h3>{{ details.project_name }}</h3>
      </a-form-model-item>
      <!-- 员工模版--结算 -->
      <a-form-model-item label="计薪方式" prop="compute">
        <a-radio-group v-model="form.compute">
          <a-radio
            v-for="(element, k) in settleType"
            :key="k"
            :value="element.id"
            >{{ element.name }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        label="计算金额"
        v-show="form.compute != '' && form.compute != undefined"
      >
        <ul class="subList">
          <li v-show="form.compute == 1">
            <label><i>*</i>单价&nbsp;</label>
            <a-input-number
              v-model="form.guard_price"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
          <li v-show="form.compute == 2">
            <label><i>*</i>每小时&nbsp;</label>
            <a-input-number
              v-model="form.guard_time_price"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
          <li v-show="form.compute == 3">
            <label><i>*</i>底薪&nbsp;</label>
            <a-input-number
              v-model="form.guard_base_salary"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
          <li v-show="form.compute == 4">
            <label><i>*</i>计件底薪&nbsp;</label>
            <a-input-number
              v-model="form.guard_four_base_salary"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
          <li v-show="form.compute == 4">
            <label><i>*</i>计件价格&nbsp;</label>
            <a-input-number
              v-model="form.guard_four_price"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
        </ul>
      </a-form-model-item>
      <a-form-model-item
        style="margin-top: 50px"
        :wrapper-col="{ span: 12, offset: 6 }"
      >
        <a-button @click="resetForm">重置</a-button>
        <a-button style="margin-left: 10px" type="primary" @click="handleSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      form: {
        workerOrder: 1,
        workerSettle: 1,
        compute: "",
        guard_price: "",
        guard_time_price: "",
        guard_base_salary: "",
        guard_four_base_salary: "",
        guard_four_price: ""
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      rules: {
        compute: [
          {
            required: true,
            message: "请选择计薪方式",
            trigger: "change"
          }
        ]
      },
      proList: [],
      independentTrue: false,
      independentFalse: false,
      roleList: [],
      details: {},
      settleType: []
    };
  },
  mounted() {
    this.getPro(); //获取客户列表
    if (this.editDetail != undefined) {
      this.getDetails();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.editDetail;
      // console.log(this.details);
      if (this.details.guard_config != undefined) {
        this.form = {
          independent: this.details.guard_config.guard_single_config,
          guard_price: this.details.guard_config.guard_price,
          guard_time_price: this.details.guard_config.guard_time_price,
          guard_base_salary: this.details.guard_config.guard_base_salary,
          guard_four_base_salary: this.details.guard_config
            .guard_four_base_salary,
          guard_four_price: this.details.guard_config.guard_four_price,
          compute:
            this.details.guard_config.guard_count_type == 0
              ? ""
              : this.details.guard_config.guard_count_type
        };
        if (this.details.project_config.guard_count_type != "") {
          this.settleType = [];
          this.details.project_config.guard_count_type.forEach(element => {
            switch (element) {
              case 1:
                this.settleType.push({
                  id: element,
                  name: "单价"
                });
                break;
              case 2:
                this.settleType.push({
                  id: element,
                  name: "时薪"
                });
                break;
              case 3:
                this.settleType.push({
                  id: element,
                  name: "底薪"
                });
                break;
              case 4:
                this.settleType.push({
                  id: element,
                  name: "计件"
                });
                break;
            }
          });
        }
      }
    },
    selectProID() {
      this.getRole();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          trade_id: 5,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    verify() {
      let fls = true;
      if (this.form.compute == 1 && this.form.guard_price == "") {
        fls = false;
        this.$message.warning("请填写单价！");
        return fls;
      }
      if (this.form.compute == 2 && this.form.guard_time_price == "") {
        fls = false;
        this.$message.warning("请填写时薪！");
        return fls;
      }
      if (this.form.compute == 3 && this.form.guard_base_salary == "") {
        fls = false;
        this.$message.warning("请填写底薪！");
        return fls;
      }
      if (this.form.compute == 4 && this.form.guard_four_base_salary == "") {
        fls = false;
        this.$message.warning("请填写计件底薪！");
        return fls;
      }
      if (this.form.compute == 4 && this.form.guard_four_price == "") {
        fls = false;
        this.$message.warning("请填写计件价格！");
        return fls;
      }
      return fls;
    },
    resetForm() {
      this.form.guard_price == "";
      this.form.guard_time_price == "";
      this.form.guard_base_salary == "";
      this.form.guard_four_base_salary == "";
      this.form.guard_four_price == "";
      this.$refs.ruleForm.resetFields();
    },
    handleSubmit(e) {
      e.preventDefault();
      let fls = this.verify();
      //   console.log(attr_config);
      this.$refs.ruleForm.validate(valid => {
        // console.log(this.form);
        if (valid) {
          if (fls) {
            let url =
              this.httpsBasic.url +
              this.httpsBasic.people +
              "Guard/setUserAccountConfig";
            let params = {
              user_id: this.details.id,
              project_id: this.details.project_id,
              guard_count_type: this.form.compute,
              guard_price: this.form.guard_price,
              guard_time_price: this.form.guard_time_price,
              guard_base_salary: this.form.guard_base_salary,
              guard_four_base_salary: this.form.guard_four_base_salary,
              guard_four_price: this.form.guard_four_price,
              token: window.localStorage.getItem("xnwfPcToken")
            };
            // console.log(params);
            axios.post(url, params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.resetForm();
                this.$emit("hideInEdit", true);
              } else {
                this.$message.warning(res.data.message);
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fromStyle {
  padding-bottom: 30px;
  padding-top: 50px;
}
.subList {
  li {
    // margin-bottom: 10px;
    display: inline-block;
    margin-right: 30px;
    i {
      font-size: 14px;
      color: #f56c6c;
      font-style: normal;
      display: inline-block;
      margin-right: 4px;
    }
  }
}
</style>
